import Image from 'next/image'
import Link from 'next/link'

export default function AutomationSection() {
    const features = [
        {
            title: 'Recovery Optimization',
            desc: 'Dynamic retry scheduling increases recovery rates up to 3x compared to manual processes.',
            icon: '/revinu/c1.png',
        },
        {
            title: 'Operational Efficiency',
            desc: 'Eliminates spreadsheet tracking, follow-ups, and manual retry management.',
            icon: '/revinu/c2.png',
        },
        {
            title: 'Revenue Intelligence',
            desc: 'Provides breakdown by failure category, recovery rates, and high-risk pending amounts.',
            icon: '/revinu/c3.png',
        },
    ]

    return (
        <section className='bg-gradient-to-br from-gray-50 to-blue-50 py-32 px-6 lg:px-28'>
            <div className='max-w-[1750px] mx-auto grid items-center gap-20 lg:grid-cols-2'>
                {/* LEFT CONTENT */}
                <div className='flex flex-col gap-6'>
                    {/* Badge */}
                    <div className='inline-block w-fit rounded-full border border-sky-200 bg-white px-4 py-2 text-xs font-bold uppercase tracking-widest text-sky-700 shadow-sm'>
                        Built for Scale
                    </div>

                    {/* Heading */}
                    <h2 className='text-4xl font-bold leading-tight text-gray-900 lg:text-5xl'>
                        Intelligent Automation <br />
                        for <span className='text-indigo-600'>Modern Revenue</span>
                        <br />
                        Operations
                    </h2>

                    {/* Description */}
                    <p className='text-lg leading-relaxed text-gray-600'>
                        Revinu operates as a dedicated payment recovery layer within your billing
                        ecosystem. It continuously monitors failures, applies decision logic, and
                        executes recovery strategies without manual intervention.
                    </p>

                    {/* Button */}
                    <Link href='/contact?ref=revinue' className='w-fit rounded-lg bg-gradient-to-r from-sky-600 to-purple-600 px-8 py-4 font-semibold text-white shadow-lg inline-block'>
                        Schedule Consultation
                    </Link>
                </div>

                {/* RIGHT CARDS */}
                <div className='flex flex-col gap-6'>
                    {features.map((item, index) => (
                        <div
                            key={index}
                            className='rounded-2xl border border-gray-200 bg-white p-8 shadow-sm transition hover:shadow-md'>
                            <div className='flex items-start gap-5'>
                                {/* Icon */}
                                <div className='rounded-xl border border-sky-200 bg-gradient-to-br from-sky-100 to-transparent p-3'>
                                    <Image src={item.icon} alt={item.title} width={32} height={32} className='object-contain' />
                                </div>

                                {/* Text */}
                                <div>
                                    <h3 className='mb-2 text-xl font-bold text-gray-900'>
                                        {item.title}
                                    </h3>

                                    <p className='text-sm leading-relaxed text-gray-600'>
                                        {item.desc}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
